import { render, staticRenderFns } from "./policySub.vue?vue&type=template&id=34670bba&scoped=true&"
import script from "./policySub.vue?vue&type=script&lang=js&"
export * from "./policySub.vue?vue&type=script&lang=js&"
import style0 from "./policySub.vue?vue&type=style&index=0&id=34670bba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34670bba",
  null
  
)

export default component.exports